<template>
    <div>
        <b-navbar toggleable="md" variant="primary" type="dark">
            <b-navbar-brand :to="{ name: 'Membership' }">Portal Super Admin</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item class="ml-2" @click="logOut" :active="true" v-b-tooltip.hover.bottom title="Cerrar sesión">
                        <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <router-view :settings="settings"></router-view>
    </div>
</template>

<script>

import { superAdminlogOutUrl } from '@routes';
import * as constants from '@/js/constants';

export default {
    data() {
        return {
            user: {
                id: 0,
                name: '',
                email: ''
            },
            settings: {
                id: 0,
                theme: {
                    variant: 'light'
                }
            }
        }
    },
    created() {
        let userSettings = null;

        if (localStorage.getItem('userSettings')) {
            userSettings = JSON.parse(localStorage.getItem('userSettings'));

            if ('theme' in userSettings) {
                this.settings.theme = userSettings.theme;
            }
        }

        let user = JSON.parse(localStorage.getItem('userInfo'));

        if (user) {
            this.user.id = user.id;
            this.user.name = user.name;
        }
    },
    methods: {
        logOut() {
            this.axios.delete(superAdminlogOutUrl()).finally(() => {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('clientId');
                localStorage.removeItem('clientSecret');

                this.user = {
                    id: 0,
                    name: '',
                    email: ''
                };

                this.$router.replace({ name: 'SuperAdminLogin' });
            });
        },
        capitalize(value) {
            if (!value) {
                return '';
            }

            value.toString();

            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    computed: {
        SUPER_ADMIN_DOCS() {
            return constants.SUPER_ADMIN_DOCS;
        }
    }
}
</script>

<style>

</style>